<template>
    <BaseModal col-md="col-md-6" offset="3" :subtitulo="tabSelect === 'info' ? 'Informações do Imóvel' : 'Editar Imóvel'"
    :modalColor="tabSelect === 'info' ? 'border-primary bg-success' : 'border-warning bg-warning'">
        <template v-slot:modalContent>
            <div class="tabs-container">
                <ul class="nav nav-tabs">
                    <li v-if="tabSelect === 'info'">
                        <a class="nav-link" :class="tabSelect === 'info' ? 'active' : ''" data-toggle="tab" href="#tab-1" id="infoTabs">Informações</a>
                    </li>
                    <li v-if="tabSelect === 'edit'">
                        <a class="nav-link" :class="tabSelect === 'edit' ? 'active' : ''" data-toggle="tab" href="#tab-2" id="editarTabs">Editar imóvel</a>
                    </li>
                    <li>
                        <a class="nav-link"  data-toggle="tab" href="#tab-3" id="imagensTabs">Imagens</a>
                    </li>
                </ul>
                <div class="tab-content">
                    <div v-if="tabSelect === 'info'" id="tab-1" class="tab-pane" :class="tabSelect === 'info' ? 'active' : ''">
                        <div class="panel-body">
                            <InformacoesImovel
                                :imovelId=imovelId
                                :imovelKey="imovelKey"
                                @fechar="$emit('fechar')"
                            />
                        </div>
                    </div>
                    <div v-if="tabSelect === 'edit'" id="tab-2" class="tab-pane" :class="tabSelect === 'edit' ? 'active' : ''">
                        <div class="panel-body">
                            <EditarImovel 
                                :imovelId=imovelId
                                :imovelKey="imovelKey"
                                @fechar="$emit('fechar')"
                                @atualizarImovel="$emit('atualizarImovel', $event)" 
                            />
                        </div>
                    </div>
                    <div id="tab-3" class="tab-pane">
                        <div class="panel-body">
                            <ImagensImovel 
                                :imovelKey="imovelKey"
                                @fechar="$emit('fechar')"
                            />
                        </div>
                    </div>
                </div>
            </div>
        </template>
    </BaseModal>
</template>

<script>
import BaseModal from '@/components/base/BaseModal.vue';
import InformacoesImovel from './InformacoesImovel.vue';
import EditarImovel from './EditarImovel.vue';
import ImagensImovel from './ImagensImovel.vue';

export default {
    name: "TabsModalImovel",
    components: {
        BaseModal,
        InformacoesImovel,
        EditarImovel,
        ImagensImovel,
    },
    props: {
        imovelId: Number,
        imovelKey: String,
        tabSelect: String,
    },
  emits: ["fechar", "atualizarImovel"],
    data() {
        return {
            erro: null,
        };
    },
};
</script>
